import React, { useState } from 'react';
import './index.css';

const WaIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const WaFloat = () => (
  <a className="wa-float" href="https://wa.me/5531998556133" target="_blank" rel="noopener noreferrer" aria-label="Abrir no WhatsApp">
    <WaIcon />
    <span>Entrar no canal</span>
  </a>
);

const Nav = () => (
  <nav>
    <div className="nav-inner">
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span className="logo-mark">Anamnes<span className="ia">IA</span></span>
        <span className="beta-pill">beta</span>
      </div>
      <a className="nav-cta" href="https://wa.me/5531998556133" target="_blank" rel="noopener noreferrer">Acessar grátis</a>
    </div>
  </nav>
);

const WaMockup = () => (
  <div className="wa-mockup">
    <div className="mock-header">
      <div className="mock-av">
        <WaIcon />
      </div>
      <div>
        <div className="mock-name">Anamnes<span style={{ color: 'var(--teal-mid)' }}>IA</span></div>
        <div className="mock-status">Assistente clínica · responde agora</div>
      </div>
      <div className="mock-badge">online</div>
    </div>

    <div className="bubble">
      <div className="proto-label">🩺 Cetoacidose Diabética — Conduta inicial</div>
      <div className="row">Hidratação: SF 0,9% 10–20 mL/kg na 1ª hora</div>
      <div className="row">Insulina: só após K⁺ &gt; 3,5 mEq/L</div>
      <div className="row">Insulina regular: 0,05–0,1 UI/kg/h EV</div>
      <div className="row">Correção de K⁺ se &lt; 5,5 mEq/L + diurese</div>
      <div className="row">Checar: glicemia/h, K⁺/2h, gasometria/4h</div>
      <div className="row">UTI se Glasgow &lt; 14, pH &lt; 7,0 ou choque</div>
      <div className="ts">agora ✓✓</div>
    </div>
    <div className="bubble bubble-sm" style={{ marginTop: '6px' }}>
      <p>Baseado em múltiplos protocolos nacionais e internacionais. Ajuste ao protocolo institucional.</p>
      <div className="ts">agora ✓✓</div>
    </div>
    <div className="typing-row">
      <div className="t-dot"></div><div className="t-dot"></div><div className="t-dot"></div>
      <span>próxima pergunta — respondo agora</span>
    </div>
  </div>
);

const Hero = () => (
  <div className="hero">
    <div>
      <div className="eyebrow-pill"><span className="dot"></span>Assistente clínica no WhatsApp</div>
      <h1>A resposta clínica certa, no momento do <em>plantão.</em></h1>
      <p className="hero-sub">
        AnamnesIA responde em tempo real direto no seu WhatsApp —
        doses, condutas, critérios, diagnósticos diferenciais e muito mais.
        Para todas as especialidades. Grátis.
      </p>
      <div className="hero-ctas">
        <a className="btn-primary" href="https://wa.me/5531998556133" target="_blank" rel="noopener noreferrer">
          <WaIcon />
          Acessar canal gratuito
        </a>
        <div className="trust-row">
          <div className="avatars">
            <div className="av">MR</div><div className="av">JC</div><div className="av">AS</div><div className="av">+</div>
          </div>
          <span className="trust-text"><strong>+300 profissionais</strong> já usam no plantão</span>
        </div>
      </div>
    </div>
    <WaMockup />
  </div>
);

const ProblemSection = () => (
  <section className="sec-dark">
    <div className="sec-inner">
      <div className="sec-label">o problema</div>
      <h2>Você sabe a conduta.<br />O protocolo precisa estar agora.</h2>
      <div className="scenario">
        "Plantão noturno. Paciente adulto, <em>dor torácica, PA 180/110</em>. Qual o critério de trombólise mesmo? O UpToDate tá travando e a equipe tá te olhando."
      </div>
      <div className="pain-grid">
        <div className="pain-card">
          <h4>Informação dispersa</h4>
          <p>PDFs no Drive, foto no celular, livro em casa. Protocolo certo na hora errada.</p>
        </div>
        <div className="pain-card">
          <h4>Ferramentas lentas</h4>
          <p>UpToDate, MedScape, Dynamed. Ótimas — mas abrir, buscar e ler no plantão tem custo real de tempo.</p>
        </div>
        <div className="pain-card">
          <h4>Guidelines que mudam</h4>
          <p>O que você aprendeu na residência pode não ser mais o padrão vigente. Atualizar é trabalhoso.</p>
        </div>
        <div className="pain-card">
          <h4>PSF, enfermaria, urgência</h4>
          <p>Cada cenário tem protocolos específicos. Não existe uma só fonte que cubra tudo de forma prática.</p>
        </div>
      </div>
    </div>
  </section>
);

const SolutionSection = () => (
  <section className="sec" style={{ background: 'var(--bg)' }}>
    <div className="sec-inner">
      <div className="sec-label">a solução</div>
      <h2>Uma assistente clínica que<br />responde na hora, no WhatsApp.</h2>
      <p className="sec-sub">AnamnesIA agrega protocolos de múltiplas sociedades médicas nacionais e internacionais e entrega a resposta certa, no canal que você já tem aberto.</p>
      <div className="solucao-grid">
        <div className="sol-card">
          <div className="sol-num">01 — VELOCIDADE</div>
          <h3>Resposta imediata, sem busca</h3>
          <p>Você pergunta em linguagem natural — "dose de ceftriaxona pneumonia adulto", "critério de IOT", "sepse conduta". AnamnesIA responde em segundos.</p>
        </div>
        <div className="sol-card">
          <div className="sol-num">02 — AMPLITUDE</div>
          <h3>Todas as especialidades e cenários</h3>
          <p>Urgência, emergência, PSF, APS, ambulatório, enfermaria, pediatria, clínica médica, cardiologia, infectologia, obstetrícia e muito mais.</p>
        </div>
        <div className="sol-card">
          <div className="sol-num">03 — SEGURANÇA</div>
          <h3>Baseada em evidências, com cautela real</h3>
          <p>Protocolos de sociedades nacionais e internacionais. Alertas de gravidade, doses máximas, contraindicações e orientação para checar protocolo local quando necessário.</p>
        </div>
      </div>
    </div>
  </section>
);

const HowItWorks = () => (
  <section className="sec-green">
    <div className="sec-inner">
      <div className="sec-label">como funciona</div>
      <h2>Zero curva de aprendizado.</h2>
      <div className="steps">
        <div className="step">
          <div className="step-num">01</div>
          <h3>Entre no canal</h3>
          <p>Um clique. Sem cadastro, sem app extra, sem senha. Só o WhatsApp que você já usa.</p>
        </div>
        <div className="step">
          <div className="step-num">02</div>
          <h3>Pergunte do jeito que falar</h3>
          <p>"dose de midazolam sedação", "sepse critérios", "crise HAS conduta", "neutropenia febril antibiótico".</p>
        </div>
        <div className="step">
          <div className="step-num">03</div>
          <h3>Receba e aplique</h3>
          <p>Resposta em bullet points, doses calculadas, alertas de gravidade e ressalvas práticas. Salve nos favoritos.</p>
        </div>
      </div>
    </div>
  </section>
);

const Specialties = () => {
  const topics = [
    { name: 'Urgência & emergência', cat: 'PA / UPA / ED' },
    { name: 'Pediatria', cat: 'PS pediátrico / ambulatório' },
    { name: 'Atenção primária', cat: 'PSF / UBS / APS' },
    { name: 'Clínica médica', cat: 'Enfermaria / hospital' },
    { name: 'Infectologia', cat: 'Antibióticos / sepse' },
    { name: 'Cardiologia', cat: 'SCA / IC / arritmias' },
    { name: 'Neurologia', cat: 'AVC / convulsão / cefaleia' },
    { name: 'Pneumologia', cat: 'DPOC / asma / TEP' },
    { name: 'Endocrinologia', cat: 'DM / tireoide / adrenal' },
    { name: 'Nefrologia', cat: 'IRA / distúrbios / TRS' },
    { name: 'Ginecologia & Obstetrícia', cat: 'Gestação de risco / emergências' },
    { name: 'Saúde mental', cat: 'Crise / psiquiatria / PS' },
    { name: 'Geriatria', cat: 'Polifarmácia / síndromes' },
    { name: 'Toxicologia', cat: 'Intoxicações / antídotos' },
    { name: 'Trauma & ortopedia', cat: 'ATLS / fratura / dor' },
    { name: 'Analgesia & sedação', cat: 'Doses / escalonamento' }
  ];

  return (
    <section className="sec" style={{ background: 'var(--surface)' }}>
      <div className="sec-inner">
        <div className="sec-label">cobertura clínica</div>
        <h2>Todas as áreas da medicina.</h2>
        <p className="sec-sub">Não só emergência. Desde o PSF até a UTI — AnamnesIA cobre os cenários onde médicos precisam de uma resposta rápida e prática.</p>
        <div className="topics-grid">
          {topics.map((t, idx) => (
            <div className="topic-chip" key={idx}>
              <div className="chip-dot"></div>
              <div>
                <div className="chip-name">{t.name}</div>
                <div className="chip-cat">{t.cat}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Testimonials = () => (
  <section className="sec" style={{ background: 'var(--bg)' }}>
    <div className="sec-inner">
      <div className="sec-label">membros beta</div>
      <h2>Quem já usa no plantão.</h2>
      <div className="testi-grid">
        <div className="testi-card">
          <div className="stars">★★★★★</div>
          <p className="testi-text">"Finalmente uma ferramenta que entende que no plantão eu preciso de uma resposta em 10 segundos, não de um artigo de 20 páginas. AnamnesIA é isso."</p>
          <div className="author">
            <div className="author-av">MR</div>
            <div>
              <div className="author-name">Dra. Marina R.</div>
              <div className="author-cred">Clínica Médica · São Paulo, SP</div>
            </div>
          </div>
        </div>
        <div className="testi-card">
          <div className="stars">★★★★★</div>
          <p className="testi-text">"Uso na UBS e no pronto-atendimento. O formato em bullet, com doses e critérios de encaminhamento, é exatamente o que preciso para as duas realidades."</p>
          <div className="author">
            <div className="author-av">JC</div>
            <div>
              <div className="author-name">Dr. João C.</div>
              <div className="author-cred">Médico de Família · Belo Horizonte, MG</div>
            </div>
          </div>
        </div>
        <div className="testi-card">
          <div className="stars">★★★★★</div>
          <p className="testi-text">"Sou R3 de clínica médica. AnamnesIA virou meu segundo preceptor no plantão. Rápida, direta, e avisa quando preciso checar o protocolo do serviço."</p>
          <div className="author">
            <div className="author-av">LS</div>
            <div>
              <div className="author-name">Dra. Luísa S.</div>
              <div className="author-cred">Residente de Clínica Médica · Rio de Janeiro, RJ</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const BetaCTA = () => (
  <section className="sec-cta">
    <div className="sec-inner">
      <div className="sec-label">acesso gratuito</div>
      <div className="status-pill"><span className="dot"></span>Canal beta aberto · sem custo · sem compromisso</div>
      <h2>Comece agora.<br />É só um clique.</h2>
      <p className="sec-sub">Acesso beta 100% gratuito. Sem cadastro, sem app extra. Só o WhatsApp.</p>
      <a className="btn-primary" href="https://wa.me/5531998556133" target="_blank" rel="noopener noreferrer" style={{ margin: '0 auto' }}>
        <WaIcon />
        Acessar AnamnesIA — grátis
      </a>
      <div><a className="btn-secondary" href="#faq">Ver perguntas frequentes</a></div>
    </div>
  </section>
);

const FAQList = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqs = [
    {
      q: "É realmente gratuito?",
      a: "Sim. O canal beta é 100% gratuito. Não existe cobrança, plano oculto ou limite de mensagens no acesso atual. No futuro pode existir um tier premium — mas o acesso base sempre será livre.",
      linkText: "Quero entrar no canal",
      linkUrl: "https://wa.me/5531998556133?text=Ol%C3%A1%21+Quero+saber+mais+sobre+o+acesso+gratuito+ao+AnamnesIA+%F0%9F%A9%BA"
    },
    {
      q: "Quais especialidades são cobertas?",
      a: "Todas. AnamnesIA cobre urgência, emergência, pediatria, clínica médica, atenção primária, cardiologia, infectologia, neurologia, endocrinologia, nefrologia, ginecologia, obstetrícia, psiquiatria, geriatria, toxicologia, trauma e muito mais.",
      linkText: "Testar agora",
      linkUrl: "https://wa.me/5531998556133?text=Ol%C3%A1%21+Quero+ver+as+especialidades+cobertas+pelo+AnamnesIA+%F0%9F%8F%A5"
    },
    {
      q: "Quem produz e revisa o conteúdo?",
      a: "O conteúdo é curado por médicos com atuação clínica ativa, baseado em múltiplos guidelines de sociedades brasileiras e internacionais (SBP, AMB, SBMFC, AHA, WHO, ESC, IDSA, entre outras). As respostas agregam fontes diversas e orientam checar protocolo local para decisões críticas.",
      linkText: "Falar sobre o projeto",
      linkUrl: "https://wa.me/5531998556133?text=Ol%C3%A1%21+Gostaria+de+saber+mais+sobre+as+fontes+e+curadoria+do+AnamnesIA+%F0%9F%93%8B"
    },
    {
      q: "Posso sugerir temas, guidelines ou correções?",
      a: "Sim, e é muito bem-vindo. Membros beta têm canal direto para sugerir especialidades, guidelines, temas, correções e melhorias. O roadmap do AnamnesIA é construído com o feedback de quem usa no dia a dia.",
      linkText: "Enviar sugestão",
      linkUrl: "https://wa.me/5531998556133?text=Ol%C3%A1%21+Tenho+uma+sugest%C3%A3o+de+tema+ou+guideline+para+o+AnamnesIA+%F0%9F%92%A1"
    },
    {
      q: "AnamnesIA substitui o julgamento clínico?",
      a: "Não. AnamnesIA é uma assistente de apoio ao profissional de saúde — não uma substituta. Toda resposta é suporte de decisão, não prescrição. O julgamento clínico final, a avaliação presencial e o protocolo institucional sempre prevalecem.",
      linkText: "Tirar dúvida agora",
      linkUrl: "https://wa.me/5531998556133?text=Ol%C3%A1%21+Tenho+d%C3%BAvidas+sobre+como+usar+o+AnamnesIA+com+seguran%C3%A7a+%E2%9A%95%EF%B8%8F"
    },
    {
      q: "Funciona offline? Preciso ter acesso à internet?",
      a: "As respostas exigem internet (como qualquer conversa no WhatsApp). Mas você pode salvar as mensagens nos favoritos do WhatsApp e acessá-las offline quando precisar. Um protocolo salvo fica disponível sem conexão.",
      linkText: "Acessar agora",
      linkUrl: "https://wa.me/5531998556133?text=Ol%C3%A1%21+Quero+entrar+no+canal+do+AnamnesIA+%F0%9F%93%B1"
    }
  ];

  return (
    <section className="sec" id="faq" style={{ background: 'var(--bg)' }}>
      <div className="sec-inner">
        <div className="sec-label">perguntas frequentes</div>
        <h2>Dúvidas comuns.</h2>
        <div className="faq-list">
          {faqs.map((faq, idx) => (
            <div className={`faq-item ${openIndex === idx ? 'open' : ''}`} key={idx}>
              <button className="faq-trigger" onClick={() => toggleFaq(idx)}>
                <h4>{faq.q}</h4>
                <div className="faq-icon">+</div>
              </button>
              <div className={`faq-body ${openIndex === idx ? 'visible' : ''}`}>
                <p>{faq.a}</p>
                <a className="faq-wa-btn" href={faq.linkUrl} target="_blank" rel="noopener noreferrer">
                  <WaIcon />
                  {faq.linkText}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const SignatureSection = () => (
  <section className="signature-sec">
    <div className="signature-inner">
      <div className="sig-label">sobre o projeto</div>
      <div className="sig-name">Dr. Carlos Eduardo Miranda Bruzzi Felipe</div>
      <p className="sig-credentials">
        Médico · CRM/MG 105.721<br />
        EI DOC Sociedade Unipessoal Ltda.<br />
        Criador e curador médico do AnamnesIA
      </p>
    </div>
  </section>
);

const Footer = () => (
  <footer>
    <div className="footer-inner">
      <span className="footer-logo">Anamnes<span className="ia">IA</span></span>
      <p className="footer-disc">
        AnamnesIA é uma assistente clínica de apoio ao profissional de saúde. O conteúdo tem finalidade exclusivamente educacional e de suporte à decisão clínica, não substituindo julgamento médico, avaliação presencial, protocolos institucionais ou diretrizes locais. © 2025 AnamnesIA · Dr. Carlos Eduardo Miranda Bruzzi Felipe · Todos os direitos reservados.
      </p>
    </div>
  </footer>
);

export default function App() {
  return (
    <>
      <WaFloat />
      <Nav />
      <Hero />
      <ProblemSection />
      <SolutionSection />
      <HowItWorks />
      <Specialties />
      <Testimonials />
      <BetaCTA />
      <FAQList />
      <SignatureSection />
      <Footer />
    </>
  );
}